export default __webpack_public_path__ + "static/1.2_FR-831e7163446cb65542cfc84a427579d4.webp";